import { validateEmail, validateLastName, validateName, validateOrganisationName, validateOTP, validatePassword } from "../components/auth/validationHelpers";

const ValidationStrategy = {
  email: validateEmail,
  username: validateName,
  first_name: validateName,
  last_name: validateLastName,
  organisation_name: validateOrganisationName,
  password: validatePassword,
  otp : validateOTP,
};

export const validateField = (fieldName, value) => {
  const validator = ValidationStrategy[fieldName];
  return validator ? validator(value) : "";
};
